import Animation from './Animation';
import './LevelUp.css';
import { play } from '../../../SoundManager';

export default class LevelUp extends Animation {

	constructor (master) {

		const fastmode = document.querySelector(".fastmode");
		super(master, fastmode ? 0 : 2500);
		this.loadAudio("heartbeat", 1000);
	}

	run () {

		var el = document.querySelector(".level-up-screen");
		if (el) {
			el.classList.add("level-up-animation");
			setTimeout(() => el.classList.remove("level-up-animation"), 4000);
		}
	}
}